import React, { createContext, useContext, useState, useEffect } from 'react';
import { db } from '../firebase/config';
import { doc, getDoc } from 'firebase/firestore';

const BrandContext = createContext();

export const BrandProvider = ({ slug, children }) => {
  const [brand, setBrand] = useState(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    if (!slug) { setLoading(false); return; }
    const fetchBrand = async () => {
      try {
        const snap = await getDoc(doc(db, 'brands', slug));
        if (snap.exists()) {
          const data = { id: snap.id, ...snap.data() };
          setBrand(data);
          // Apply brand CSS variables
          document.documentElement.style.setProperty('--brand-primary', data.primaryColor || '#111111');
          document.documentElement.style.setProperty('--brand-secondary', data.secondaryColor || '#ffffff');
        } else {
          setNotFound(true);
        }
      } catch (e) {
        setNotFound(true);
      }
      setLoading(false);
    };
    fetchBrand();
  }, [slug]);

  return (
    <BrandContext.Provider value={{ brand, loading, notFound }}>
      {children}
    </BrandContext.Provider>
  );
};

export const useBrand = () => useContext(BrandContext);
